import { Link } from 'react-router';

import type { SameNumberLead } from '../api/types';
import { useProject } from '../projects/context';
import { addressLine, fmtDateTime } from './format';

// SameNumberLeads: Leads anderer Personen mit derselben Telefonnummer (z. B. Ehepartner mit eigenem Objekt). Weitere
// Objekte desselben Eigentümers zeigt der Eigentümer-Kasten. Kontaktstopp, Kontaktpause und Mindestabstand gelten für die
// Nummer.
export function SameNumberLeads({ items, compact = false }: { items: SameNumberLead[]; compact?: boolean }) {
  const { project } = useProject();
  if (items.length === 0) return null;
  const blocked = items.some((i) => i.do_not_call);
  return (
    <section className={compact ? 'same-number compact' : 'card same-number'} aria-labelledby="same-number-title">
      <h3 id="same-number-title">
        Gleiche Nummer bei {items.length === 1 ? 'einer anderen Person' : `${items.length} anderen Leads`}
      </h3>
      <p className="muted small">
        {blocked
          ? 'Kontaktstopp bei einem dieser Leads – er gilt für die Nummer, nicht anrufen.'
          : 'Kontaktstopp, Kontaktpause und Mindestabstand gelten für die Nummer.'}
      </p>
      <ul className="same-number-list">
        {items.map((i) => (
          <li key={i.id}>
            <Link to={`/p/${project.key}/leads/${i.id}`} target={compact ? '_blank' : undefined} rel={compact ? 'noreferrer' : undefined}>
              {i.name}
            </Link>
            <span className="muted"> · {addressLine(i)}</span>
            <span className="badges">
              <span className="badge badge-muted">{i.status_label}</span>
              {i.do_not_call && <span className="badge badge-error">Kontaktstopp</span>}
              {i.next_appointment_at && <span className="badge badge-ok">Termin {fmtDateTime(i.next_appointment_at)}</span>}
            </span>
            {(i.field_sales_name || i.area_name || i.last_call_at) && (
              <span className="muted block">
                {[i.area_name && `Gebiet ${i.area_name}`, i.field_sales_name, i.last_call_at && `zuletzt angerufen ${fmtDateTime(i.last_call_at)}`]
                  .filter(Boolean)
                  .join(' · ')}
              </span>
            )}
          </li>
        ))}
      </ul>
    </section>
  );
}
